export interface IAuthResponse {
    otp_expiry: string;
}


export interface IAuthWithPasswordResponse {
    isNewUser: boolean;
    token: string;
}

export interface IOtpValidateResponse {
    isNewUser: boolean;
    token: string;
}


export interface IGoogleLoginResponse {
    token: string;
    isNewUser: boolean;
}


export interface IUserDetailsWithSessionResponse {
    access_token: string;
    email: string;
    first_name: string | null;
    first_time_login: boolean;
    last_name: string | null;
    message: string;
    user_id: string;
}

export interface IUserDetails {
    accessToken: string;
    email: string;
    firstName: string | null;
    lastName: string | null;
    userId: string
    isFirstTimeLogin: boolean;
}

export interface ISession {
    accessToken: string;
    isNewUser: boolean;
}

export const toSession = ({token: accessToken, isNewUser}) => ({accessToken, isNewUser})
export const toUserDetails = (userDetails: IUserDetailsWithSessionResponse): IUserDetails => ({
    accessToken: userDetails.access_token,
    email: userDetails.email,
    firstName: userDetails.first_name,
    lastName: userDetails.last_name,
    userId: userDetails.user_id,
    isFirstTimeLogin: userDetails.first_time_login
})